import Button from '@anm/components/buttons/Button';
import getFromCdn from '@anm/helpers/getFromCdn';
import {
  cardCouponSectionItemStyles,
  subscriptionModalSectionWrapperStyles
} from '@anm/styles/helpers';
import styled from 'styled-components';

export const CardDetailsCouponBlockWrapper = styled.div`
  ${subscriptionModalSectionWrapperStyles};
  background-color: #e9f8ff;
  margin-bottom: 20px;
  padding: 23px 30px;
`;

export const ChangeCardButton = styled(Button)`
  background: url(${getFromCdn('images/icons/blue-underline.svg')}) no-repeat
    bottom transparent;
  height: auto;
  border-radius: 0;
`;

export const CardDetailsBlock = styled.div`
  ${cardCouponSectionItemStyles};
`;

export const ChangeCardCouponBlock = styled.div`
  ${cardCouponSectionItemStyles};
`;
